// Basename for demo
export const DEMO_PATH = '/demo';